/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_Top_Center_LabelInputs */

const en_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Center`)
};

const fr_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut centre`)
};

const de_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oben Mitte`)
};

const it_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro superiore`)
};

const ru_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верхний центр`)
};

const es_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro superior`)
};

const zh_cn2_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顶部中心`)
};

const ja_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上中央`)
};

const hi_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्ष केंद्र`)
};

const pt_pt2_style_guide_manager_position_top_center_label = /** @type {(inputs: Style_Guide_Manager_Position_Top_Center_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro superior`)
};

/**
* | output |
* | --- |
* | "Top Center" |
*
* @param {Style_Guide_Manager_Position_Top_Center_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_top_center_label = /** @type {((inputs?: Style_Guide_Manager_Position_Top_Center_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_Top_Center_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_position_top_center_label(inputs)
	if (locale === "de") return de_style_guide_manager_position_top_center_label(inputs)
	if (locale === "it") return it_style_guide_manager_position_top_center_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_position_top_center_label(inputs)
	if (locale === "es") return es_style_guide_manager_position_top_center_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_position_top_center_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_position_top_center_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_position_top_center_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_position_top_center_label(inputs)
	return en_style_guide_manager_position_top_center_label(inputs)
});